class CompareBar extends HTMLElement {
  compareButtonUpdateUnsubscriber = undefined;

  constructor() {
    super();

    this.dialog = this.querySelector("dialog");
    this.dialogButton = this.querySelector("dialog + button");
    this.closeButton = this.querySelector("dialog .close-btn");
    this.removeButtons = this.querySelectorAll(".remove-button");
    this.mobileOpenCloseButton = this.querySelector(".details-icon-wrapper");
  }

  connectedCallback() {
    this.compareButtonUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.compareButtonUpdate, event => {
        let compareItems = JSON.parse(localStorage.getItem('compare-items')) || [];
        let compareData = JSON.parse(localStorage.getItem('compare-data')) || [];

      if(event.action == 'add') {
        let item = { id: event.productId, image: event.imageSrc };
        compareItems.push(item);
        compareData.push(event.data);
        
        localStorage.setItem('compare-items', JSON.stringify(compareItems));
        localStorage.setItem('compare-data', JSON.stringify(compareData));

        this.addImage(item);

        this.classList.add('active');

        if(compareItems.length == 3) {
          publish(PUB_SUB_EVENTS.compareBarUpdate, { action: 'full' });
        }
      }

      if(event.action == 'remove') {
        compareItems = compareItems.filter(e => e.id !== event.productId);
        compareData = compareData.filter(e => e.id !== event.productId);

        localStorage.setItem('compare-items', JSON.stringify(compareItems));
        localStorage.setItem('compare-data', JSON.stringify(compareData));

        let itemElement = this.querySelector(`.item[data-id="${event.productId}"]`); 
        itemElement.querySelector('img').remove();
        itemElement.classList.remove('item');
        itemElement.removeAttribute('data-id');

        if(!compareItems.length) {
          this.classList.remove('active');
        }
      }
    });

    this.dialogButton.addEventListener('click', () => {
      let compareItems = JSON.parse(localStorage.getItem('compare-items')) || [];
      if(compareItems.length < 2) return
      
      this.dialog.showModal();
      this.renderDialogContent();
    });

    this.closeButton.addEventListener('click', () => this.dialog.close());
    this.mobileOpenCloseButton.addEventListener('click', () => this.classList.toggle('open'));

    this.removeButtons.forEach(btn => btn.addEventListener('click', (e) => {
      let productId = e.target.parentElement.dataset.id;
      let compareItems = JSON.parse(localStorage.getItem('compare-items')) || [];
      let compareData = JSON.parse(localStorage.getItem('compare-data')) || [];

      compareItems = compareItems.filter(e => e.id !== productId);
      compareData = compareData.filter(e => e.id !== productId);

      localStorage.setItem('compare-items', JSON.stringify(compareItems));
      localStorage.setItem('compare-data', JSON.stringify(compareData));

      e.target.nextElementSibling.remove();
      e.target.parentElement.classList.remove('item');
      e.target.parentElement.removeAttribute('data-id');
      publish(PUB_SUB_EVENTS.compareBarUpdate, { action: 'remove', id: productId, status: 'ok'});
      

      if(!compareItems.length) {
        this.classList.remove('active');
      }

    }));

    this.init();
  }

  get getCompareItems() {
    return JSON.parse(localStorage.getItem('compare-items')) || [];
  }

  init() {
    let compareItems = this.getCompareItems;

    if(compareItems.length) {
      compareItems.map(e => this.addImage(e));
      this.classList.add('active');
    }
  }

  addImage(elem) {
    let itemElement = this.querySelector('.empty-item:not(.item)');
    let img = document.createElement('img');
    img.src = elem.image;
    itemElement.appendChild(img);
    itemElement.classList.add('item');
    itemElement.dataset.id = elem.id;
  }

  renderDialogContent() {
      const container = document.querySelector('.compare-popup--body');
      container.innerHTML = '';
      let compareData = JSON.parse(localStorage.getItem('compare-data')) || [];

      if(compareData.length == 2) {
        container.classList.remove('column-4')
        container.classList.add('column-3')
      }
      if(compareData.length == 3) {
        container.classList.remove('column-3')
        container.classList.add('column-4')
      }
      
      container.insertAdjacentHTML('beforeend','<div class="visibility-hidden"></div>');
      compareData.forEach(e => {
        let item = `
        <div class="img">
          <img src="${e.image}" alt="">
        </div>
        `;

        container.insertAdjacentHTML('beforeend',item);
      });

      container.insertAdjacentHTML('beforeend','<div class="visibility-hidden"></div>');
      compareData.forEach(e => {
        let item = e.sku ? `<p class="sku">${e.sku}</p>` : '<p class="sku">N/A</p>';

        container.insertAdjacentHTML('beforeend',item);
      });


      container.insertAdjacentHTML('beforeend','<div class="visibility-hidden"></div>');
      compareData.forEach(e => {
        let item = e.title ? `<p class="title">${e.title}</p>` : '<p>N/A</p>';

        container.insertAdjacentHTML('beforeend',item);
      });

      container.insertAdjacentHTML('beforeend','<p class="option-title row">Price Retail</p>');
      compareData.forEach(e => {
        let item = e.price ? `<p class="option-value price">${e.price}</p>` : '<p class="option-value">N/A</p>';

        container.insertAdjacentHTML('beforeend',item);
      });

      container.insertAdjacentHTML('beforeend','<p class="option-title row">Cap Style</p>');
      compareData.forEach(e => {
        let item = e.cap ? `<p class="option-value cap">${e.cap}</p>` : '<p class="option-value">N/A</p>';

        container.insertAdjacentHTML('beforeend',item);
      });

      container.insertAdjacentHTML('beforeend','<p class="option-title row">Material Type</p>');
      compareData.forEach(e => {
        let item = e.material ? `<p class="option-value material">${e.material}</p>` : '<p class="option-value">N/A</p>';

        container.insertAdjacentHTML('beforeend',item);
      });

      container.insertAdjacentHTML('beforeend','<p class="option-title row">Case Qty</p>');
      compareData.forEach(e => {
        let item = e.qty ? `<p class="option-value qty">${e.qty}</p>` : '<p class="option-value">N/A</p>';

        container.insertAdjacentHTML('beforeend',item);
      });

      container.insertAdjacentHTML('beforeend','<p class="option-title row">Color</p>');
      compareData.forEach(e => {
        let colors = '';
        if(e.color) {
          let _colors = e.color.split(',');
          _colors.map(e => colors += `<span class="swatch" style="--swatch--background:${e};"></span>`)
        }
        let item = e.color 
          ? `<p class="option-value color">${colors}</p>` 
          : '<p class="option-value">N/A</p>';

        container.insertAdjacentHTML('beforeend',item);
      });

      container.insertAdjacentHTML('beforeend','<p class="option-title row">Capacity</p>');
      compareData.forEach(e => {
        let item = e.capacity ? `<p class="option-value capacity">${e.capacity}</p>` : '<p class="option-value">N/A</p>';

        container.insertAdjacentHTML('beforeend',item);
      });

      container.insertAdjacentHTML('beforeend','<p class="option-title row">Cap Size</p>');
      compareData.forEach(e => {
        let item = e.size ? `<p class="option-value size">${e.size}</p>` : '<p class="option-value">N/A</p>';

        container.insertAdjacentHTML('beforeend',item);
      });

      container.insertAdjacentHTML('beforeend','<p class="option-title last row">Diameter</p>');
      compareData.forEach(e => {
        let item = e.diameter ? `<p class="option-value diameter">${e.diameter}</p>` : '<p class="option-value">N/A</p>';

        container.insertAdjacentHTML('beforeend',item);
      });

      container.insertAdjacentHTML('beforeend','<div class="visibility-hidden"></div>');
      compareData.forEach(e => {
        let item = `
          <div class="option-value">
            <a class="product-url btn" href="${e.url}">View Details</a>
          </div>
        `;

        container.insertAdjacentHTML('beforeend',item);
      });

  }

}

if (!customElements.get('compare-bar')) {
    customElements.define('compare-bar', CompareBar);
}
